//@DEPRECATED
import { Input, Modal, PrimaryButton, PrimaryCardButton, RadioButtonGroup, TextArea } from '@cb/apricot-react';
import { Grid } from '@mui/material';
import { ChangeEventHandler, FC, useEffect, useState } from 'react';

import { RadioButton, WordBreak } from 'src/components';
import { authorizationLevelOptions } from 'src/constants';
import { useToasts } from 'src/hooks';
import { TRequest } from 'src/types';
import { statusUpdate } from '../../services/schoolRequest';
import { useAuth } from 'src/contexts';
import { CircularProgress } from '@mui/material';

interface ApprovedModalProps {
  isOpen?: boolean;
  onClose: VoidFunction;
  onComplete: (request: TRequest) => void;
  request: TRequest | null;
}

const ApprovedModal: FC<ApprovedModalProps> = ({
  isOpen,
  onClose,
  onComplete,
  request,
}) => {
  const { lastName, firstName, userInfo } = useAuth();
  const [schoolCode, setSchoolCode] = useState('');
  const [loading, setLoading] = useState('');
  const [aiLevel, setAiLevel] = useState('');
  const [statusComments, setStatusComments] = useState('');
  const { errorMessage, render: renderToasts, toastErrorMessage } = useToasts();

  const handleChangeSchoolCode: ChangeEventHandler<HTMLInputElement> = (event) => {
    setSchoolCode(event.target.value);
  };

  const handleChangeAiLevel = (value: string) => {
    setAiLevel(value);
  };

  const handleChangeStatusComments = (event: any) => {
    setStatusComments(event.target.value);
  };

  const handleSubmit = async () => {
    if (!request || !schoolCode || !aiLevel) {
      toastErrorMessage('Incomplete data -- please fill School Code and/or Select Level');
    } else {
      toastErrorMessage(null);
      setLoading('Saving');
      // @DEPRECATED
      // const admin = userInfo!;
      // const updates: any = {
      //   admin: admin['cognito:username'],
      //   adminEmail: admin.email,
      //   processStatus: 'completed',
      //   aiCode: schoolCode,
      //   aiLevelInd: aiLevel,
      //   processStatusComments: statusComments,
      //   schoolName: request.detail?.schoolName,
      //   creatorEmail: request.detail?.creatorEmail
      // };

      try {
        const updated = await statusUpdate(request.userId, request.categoryId, {
          user:lastName + ', ' + firstName,
          status: 'completed',
          aiCode: schoolCode,
          aiLevelInd: aiLevel,
          comment: statusComments
        });
        onComplete(request);
      } catch (error: any) {
        toastErrorMessage(error.message);
      }
      setLoading('');
    }
  };

  useEffect(() => {
    setSchoolCode('');
    setAiLevel('');
    setStatusComments('');
    toastErrorMessage(null);
  }, [isOpen, toastErrorMessage]);

  return (
    // @ts-ignore
    <Modal
      title="Grant School Code"
      actions={[
        <PrimaryButton key="submit" onClick={handleSubmit} disabled={loading ? true : false}>
          Confirm
        </PrimaryButton>,
        <PrimaryCardButton key="close" onClick={onClose} disabled={loading ? true : false}>
          Close
        </PrimaryCardButton>,
      ]}
      closeButton={false}
      open={isOpen}
      onClose={onClose}
      withHeader>
      {renderToasts()}

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WordBreak>
            <strong>Organization:</strong> {request?.detail?.schoolName}
          </WordBreak>
          <WordBreak>
            <strong>Requested By:</strong> {request?.detail?.creator}
          </WordBreak>
          <WordBreak>
            <strong>Initial Submit:</strong> {(new Date(request?.detail?.createDate || 0)).toLocaleString()}
          </WordBreak>
        </Grid>
        <Grid item xs={12}>
          <Input
            floating={false}
            label="School Code"
            required
            placeholder="School Code"
            maxLength={6}
            onChange={handleChangeSchoolCode}
            value={schoolCode}
            validation={!schoolCode && errorMessage ? 'error' : undefined}
            validationMsg={errorMessage ?? undefined}
          />
        </Grid>
        <Grid item xs={12}>
          {/* @ts-ignore */}
          <RadioButtonGroup
            name={'authorization'}
            required
            onChange={handleChangeAiLevel}
            value={aiLevel}
            validation={!aiLevel && errorMessage ? 'error' : undefined}
            validationMsg={errorMessage ?? undefined}
            vertical
            vSpacing="16">
            {authorizationLevelOptions.map((option) => (
              <RadioButton key={option.value} label={option.label} value={option.value} />
            ))}
          </RadioButtonGroup>
        </Grid>
        <Grid item xs={12}>
          <div style={{ paddingRight: '8px' }}>Reviewer Comments:</div>
          <TextArea onChange={handleChangeStatusComments} value={statusComments} maxLength={5000} />
        </Grid>
      </Grid>

      {loading &&
        <div style={{ marginTop: '20px' }}>
          <Grid item xs={12}><CircularProgress /> <div style={{ display: 'inline-block', fontSize: '20px' }}>{loading}</div></Grid>
        </div>
      }
    </Modal>
  );
};

export default ApprovedModal;
